import z from 'zod';

import { AnyBlockTypeSchema } from './flow/base/baseSchema.js';

export const flowRunTaskEventSchema = z.object({
  id: z.string(),
  _sortTimestamp: z.string(),
  metricName: z.string().optional(),
  eventName: z.string().optional(),
  metricValue: z.number(),
  useCase: z.string().nullable(),
  metadata: z.record(z.string(), z.string()).optional(),
  blockId: z.string().nullable().optional(),
  blockType: AnyBlockTypeSchema.nullable().optional(),
  blockName: z.string().nullable().optional(),
});

export type FlowRunTaskEvent = z.infer<typeof flowRunTaskEventSchema>;

export const findAllParamsSchema = z.object({
  flowRunId: z.string(),
});

export type FlowRunTaskEventFindAllParams = z.infer<typeof findAllParamsSchema>;
